import React, { useContext, useState } from "react"
import BaseModal from "../../../../components/layout/BaseModal"
import { useQueryClient } from "@tanstack/react-query"
import { ModalContext } from "../../../../components/contexts/ModalContext"
import { useAddBillMutation } from "../../api/services"
import { BillFromOfferType, BillPost, PositionData } from "../../../../data/Types"
import dayjs from "dayjs"
import BaseInputField from "../../../../components/elements/BaseInputField"
import BaseSelection from "../../../../components/elements/BaseSelection"
import BaseInputArea from "../../../../components/elements/BaseInputArea"
import BaseCheckbox from "../../../../components/elements/BaseCheckbox"
import { useForm } from "antd/es/form/Form"
import { Form } from "antd"
import { GeneralQueryKeys } from "../../../../api/constants"
import { Minus, MinusCircle, PlusCircle } from "lucide-react"

export default function BillFromOfferModal(props: BillFromOfferType) {
    const [billType, setbillType] = useState("Rechnung")

    const [billCategorie, setbillCategorie] = useState("Hausmeister")
    const [billDue, setbillDue] = useState<string>("28")
    const [billDay, setbillDay] = useState<string>("15")
    const [deliveryDate, setdeliveryDate] = useState("")
    const [positions, setpositions] = useState<PositionData[]>(props.positions)
    const [additionalText, setadditionalText] = useState<string | undefined>()
    const [forceFirstPayreqSameMonth, setforceFirstPayreqSameMonth] = useState<boolean>(false)

    const clearInput = () => {
        setbillCategorie("Hausmeister")
        setbillDay("15")
        setbillDue("28")
        setdeliveryDate("")
        setbillType("Rechnung")
        setforceFirstPayreqSameMonth(false)
        setadditionalText(undefined)
        setpositions(props.positions)
    }

    const queryClient = useQueryClient()
    const modalCon = useContext(ModalContext)
    const { mutate: addBill } = useAddBillMutation(queryClient, GeneralQueryKeys.OFFER_SINGLE + props.offer)
    const handleNewBill = () => {
        form.validateFields()
            .then(() => {
                const NewBill: BillPost = {
                    date: Date(),
                    customer_id: props.customer._id,
                    object_id: props.object._id,
                    offer_id: props.offer,
                    positions: ((form.getFieldValue("positions") as PositionData[]).map((position, index) => ({ ...position, position_id: index + 1 })) as unknown as PositionData[]) || positions,
                    billCategorie: billCategorie,
                    billType: billType,
                    billDue: Number(billDue),
                    serviceDate: dayjs(deliveryDate).format("DD.MM.YYYY"),
                    additionalText: additionalText,
                    forceFirstPayreqSameMonth: forceFirstPayreqSameMonth,
                }
                if (billType !== "Rechnung") {
                    NewBill.billDay = Number(billDay)
                }
                const formData = new FormData()
                formData.append("bill", JSON.stringify(NewBill))
                props.documents?.forEach((doc: any) => {
                    if (doc) {
                        formData.append("additionalDocuments", doc)
                    }
                })
                addBill(formData)

                clearInput()
                modalCon?.trigger(0)
            })
            .catch((error) => {
                console.log("error", error)
            })
    }

    // FE LOGIC
    const [form] = useForm()
    const onOpenModal = () => {
        setpositions(props.positions)
        form.setFieldsValue({ positions: props.positions })
    }

    // positions are read-only and managed by Form.List

    return (
        <BaseModal
            onClose={clearInput}
            onOpen={onOpenModal}
            modalId={1}
            title={"Rechnung stellen"}
            bottomRow={
                <div className="flex justify-end items-center">
                    <button className="btn btn-primary" onClick={handleNewBill} disabled={deliveryDate === ""}>
                        Rechnung stellen
                    </button>
                </div>
            }>
            <div className="flex gap-4">
                <BaseSelection label={"Rechnungstyp *"} placeholder={""} classProps="mt-4" data={["Rechnung", "Jahresrechnung", "Dauerrechnung"]} setId={setbillType} defaultValue="Rechnung" />
                <BaseSelection
                    label={"Kategorie *"}
                    placeholder={""}
                    classProps="mt-4 !w-64"
                    data={["Hausmeister", "Schlüsseldienst", "Bau", "Vermietung", "Sonstiges"]}
                    setId={setbillCategorie}
                    defaultValue="Hausmeister"
                />
            </div>
            <div className="flex flex-col w-full mt-4">
                <BaseInputField label={"Kunde *"} type={"text"} disabled onChange={() => {}} value={props.customer.name} />
            </div>
            <div className="flex flex-col w-full mt-4">
                <BaseInputField label={"Objekt *"} type={"text"} disabled onChange={() => {}} value={props.object.adress} />
            </div>
            <BaseInputField label={"Leistungsdatum"} type={"date"} value={deliveryDate} onChange={setdeliveryDate} classProps="mt-2" />
            <BaseSelection label={"Rechnungsfrist in Tagen *"} placeholder={""} classProps="mt-2" data={["7", "14", "28"]} setId={setbillDue} defaultValue="28" />
            {billType !== "Rechnung" && <BaseSelection label={"Zahltag des Monats *"} placeholder={""} classProps="mt-2" data={["1", "15", "28"]} setId={setbillDay} defaultValue="28" />}
            <BaseInputArea prevent classProps="mt-2" label={"Zusätzlicher Text auf der Rechnung"} value={additionalText} onChange={setadditionalText} />
            <p className="font-semibold pt-2">Positionen:</p>
            <div className="flex flex-col gap-2">
                <Form form={form}>
                    <Form.List name="positions">
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map((field, index) => (
                                    <div key={`position-${field.key}-${index}`} className="flex flex-col pb-2 justify-end w-full">
                                        <div className="flex w-full gap-2">
                                            <BaseInputField label={"Nr."} type={""} onChange={() => {}} width="w-16" disabled value={index + 1} />
                                            <Form.Item name={[field.name, "description"]} className="m-0 grow" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                                                <BaseInputField label={"Beschreibung"} type={""} onChange={() => {}} width="grow" />
                                            </Form.Item>
                                            <Form.Item name={[field.name, "unit"]} className="m-0" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                                                <BaseInputField label={"Einheit"} type={"text"} onChange={() => {}} width="w-40" />
                                            </Form.Item>
                                            <Form.Item name={[field.name, "tax"]} className="m-0 w-20" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                                                <BaseSelection
                                                    label={"Steuer"}
                                                    data={["19 %", "7 %"]}
                                                    setId={(e) => {
                                                        console.log("e", e)
                                                        const value = e === "19 %" ? 19 : 7
                                                        form.setFieldValue(["positions", field.name, "tax"], value)
                                                    }}
                                                    classProps="!w-20"
                                                    placeholder={""}
                                                />
                                            </Form.Item>
                                            <Form.Item name={[field.name, "amount"]} className="m-0 w-20" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                                                <BaseInputField label={"Menge"} type={"number"} onChange={() => {}} width="w-20" />
                                            </Form.Item>
                                            <Form.Item name={[field.name, "singlePrice"]} className="m-0" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                                                <BaseInputField label={"Einzelpreis"} type={"number"} onChange={() => {}} width="w-40" />
                                            </Form.Item>
                                            {fields.length > 1 && (
                                                <button
                                                    type="button"
                                                    className="w-5 h-5 my-auto -ml-1 cursor-pointer text-gray-500"
                                                    onClick={() => {
                                                        console.log("removePosition", field.name)
                                                        remove(field.name)
                                                    }}>
                                                    <MinusCircle className="w-5 h-5" />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))}
                                <p
                                    className="flex pl-4 text-sm items-center pt-2 gap-3 cursor-pointer justify-end"
                                    onClick={() => {
                                        const currentPositions = form.getFieldValue("positions") || []
                                        form.setFieldValue("positions", [
                                            ...currentPositions,
                                            {
                                                position_id: "",
                                                description: "",
                                                tax: 19,
                                                unit: "",
                                                amount: 1,
                                                singlePrice: 0,
                                            },
                                        ])
                                    }}>
                                    <PlusCircle className="w-5 h-5" />
                                    <p>Weitere Position hinzufügen</p>
                                </p>
                            </>
                        )}
                    </Form.List>
                </Form>
            </div>
            {billType !== "Rechnung" && (
                <BaseCheckbox check={forceFirstPayreqSameMonth} setcheck={setforceFirstPayreqSameMonth} classProps="justify-start mt-4" label={"Erste Zahlungsanforderung mit Rechnung erstellen"} />
            )}
        </BaseModal>
    )
}
